<div class="calendar">
  <div class="dt" *ngIf="!hideIcon">
    <mat-datepicker-toggle [for]="datepicker" [disableRipple]="true">
      <craft-icon name="general--calendar-md" matDatepickerToggleIcon></craft-icon>
    </mat-datepicker-toggle>
  </div>
  <div
    class="dt-input"
    [ngClass]="{ opened: datepicker.opened }"
    (click)="datepicker.opened ? datepicker.close() : datepicker.open()"
  >
    <mat-datepicker #datepicker (opened)="onOpen()"></mat-datepicker>
    <input readonly [matDatepicker]="datepicker" [placeholder]="placeholder" [formControl]="date" />
  </div>
</div>

<div style="display: none">
  <div class="dt-footer" #datepickerFooter>
    <button mat-button (click)="clear()" class="clear">Clear</button>
    <button mat-button (click)="done()" class="done">Apply</button>
  </div>
</div>
